<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default { 
  page: {
    title: "Genel Arıza Sorgula",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
        list: {},
        title: "GENEL ARIZA SORGULA",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "GENEL ARIZA SORGULA",
            active: true,
          },
        ],
        isLoading: false,
        rows: [],
        totalRecords: 0,
        plist:{},
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        selected: 0,
        pageLength: 0,
        url: "vae/genel-ariza-sorgula",
        paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdown: [50, 100, 200],
          nextLabel: 'Sonraki',
          prevLabel: 'Önceki',
          rowsPerPageLabel: 'Kayıt Göster',
          ofLabel: 'of',
          pageLabel: 'sayfa', // for 'pages' mode
          infoFn: params => `${params.firstRecordOnPage} - ${params.lastRecordOnPage} ( Toplam: ${params.totalRecords}) `,
      },
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: false,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
       hizmet:{},
       mudurluk:{},
       columns:  [
        {
          label: 'Çalisma Durumu',
          field: 'calismaDurumu',
          sortable: false,
        },
        {
          label: 'Armada Id',
          field: 'genelKesintiArmadaId',
          sortable: false,
        },
        {
          label: 'Mars Id',
          field: 'genelKesintiMarsId',
          sortable: false,
        },
        {
          label: 'Kesinti Tipi',
          field: 'genelKesintiTipi',
          sortable: false,
        },
        {
          label: 'Oluşturulma Tarihi',
          field: 'olusturulmaTarihi',
        },
         {
          label: 'Islah Tarihi',
          field: 'planlananIslahTarihi',
        },
      ]
    };
  },
    mounted(){},
    methods: {
        updateParams(newProps) {
            this.serverParams = { ...this.serverParams, ...newProps }
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage })
            this.loadItems()
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage })
            this.loadItems()
        },
        onSortChange(params) {
            this.updateParams({
                sort: params,
            })
            this.loadItems()
        },
        onColumnFilter(params) {
            this.updateParams(params)
            this.loadItems()
        },
        loadItems() {
            this.getFromServer(this.serverParams).then(response => {
                this.totalRecords = response.totalRecords
                this.pageLength = response.pageLength
                this.currentPage = response.currentPage
                this.rows = response.rows
            })
        },
        getFromServer() {
            return new Promise((resolve, reject) => {
                this.$http.post(this.url, this.serverParams)
                .then(res => {
                    resolve({
                    rows: res.data.data,
                    totalRecords: res.data.total,
                    pageLength: res.data.last_page,
                    currentPage: res.data.current_page,
                    })
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        selectionChanged(a) {
            this.selected = a.selectedRows.length
        },
        onSearch(params) {
            this.updateParams(params)
                this.loadItems()
        },
        create(){
            this.list = {}
            this.$parent.$bvModal.show('modal-scoped')
        },
        update(props){
            this.list = props
            this.$parent.$bvModal.show('modal-scoped')
        },
        byHizmetNo(){
            if(!this.hizmet.hizmetNo || !this.hizmet.hizmetTuru ) return
            this.serverParams = { ...this.serverParams, columnFilters: { ...this.hizmet, type:1 } }
            this.loadItems()
        },
        byMudurluk(){
            if(!this.mudurluk.start || !this.mudurluk.end || !this.mudurluk.mudurluk ) return

            this.serverParams = { ...this.serverParams, columnFilters: { ...this.mudurluk, type:2 } }
            this.loadItems()

        }
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
       <div class="col-lg-6">
            <div class="card">
                <div class="card-header bg-primary text-light">
                    Hizmet Numarasına Göre Sorgula
                </div>
                <div class="card-body">
                    <div class="d-flex">
                        <div class="col-md-6 form-group">
                            <label class="form-label">Hizmet Numarası:</label> 
                            <input type="number" v-model="hizmet.hizmetNo" value="Hizmet Numarası" class="form-control">
                        </div> 
                        <div class="col-md-6 form-group ml-1">
                            <label class="form-label">Hizmet Türü :</label> 
                            <div class="input-group ml-1">
                                <select  v-model="hizmet.hizmetTuru" class="form-select">
                                    <option selected="selected" value="">Seçim Yapınız</option> 
                                    <option value="6">PSTN</option> <option value="300">DSL</option> 
                                    <option value="301">IP TV</option> <option value="302">Web TV</option> 
                                    <option value="303">Mobil TV</option> <option value="304">Smart TV</option> 
                                    <option value="305">ISDN BA</option> <option value="307">Uydu TV</option>
                                </select> 
                                <button class="btn btn-sm btn-primary" @click="byHizmetNo()">Sorgula</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="card">
                <div class="card-header bg-primary text-light">
                    İl Müdürlüğe Göre Sorgula
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="d-flex justify-content-beetween">
                            <div class="col-md-3 form-group">
                                <label class="form-label">Başlangıç:</label> 
                                <input type="date" v-model="mudurluk.start" value="2023-12-26" class="form-control">
                            </div> 
                            <div class="col-md-3 form-group">
                                <label class="form-label">Bitiş:</label>
                                 <input type="date"  v-model="mudurluk.end" value="2023-12-26" class="form-control">
                            </div> 
                            <div class="col-md-6 form-group ml-1">
                                <label class="form-label">İl Müdürlük :</label> 
                                <div class="input-group ml-1">
                                    <select v-model="mudurluk.mudurluk"  class="form-select">
                                        <option selected="selected" value="">Seçim Yapınız</option> <option value="0">ADANA</option> <option value="1">ADIYAMAN</option> <option value="2">AFYON</option> <option value="3">AKSARAY</option> <option value="4">AMASYA</option> <option value="5">ANKARA</option> <option value="6">ANTALYA</option> <option value="7">ARDAHAN</option> <option value="8">ARTVİN</option> <option value="9">AYDIN</option> <option value="10">AĞRI</option> <option value="11">BALIKESİR</option> <option value="12">BARTIN</option> <option value="13">BATMAN</option> <option value="14">BAYBURT</option> <option value="15">BOLU</option> <option value="16">BURDUR</option> <option value="17">BURSA</option> <option value="18">BİLECİK</option> <option value="19">BİNGÖL</option> <option value="20">BİTLİS</option> <option value="21">DENİZLİ</option> <option value="22">DÜZCE</option> <option value="23">DİYARBAKIR</option> <option value="24">DİĞER</option> <option value="25">EDİRNE</option> <option value="26">ELAZIĞ</option> <option value="27">ERZURUM</option> <option value="28">ERZİNCAN</option> <option value="29">ESKİŞEHİR</option> <option value="30">GAZİANTEP</option> <option value="31">GÜMÜŞHANE</option> <option value="32">GİRESUN</option> <option value="33">HAKKARİ</option> <option value="34">HATAY</option> <option value="35">ISPARTA</option> <option value="36">IĞDIR</option> <option value="37">KAHRAMANMARAŞ</option> <option value="38">KARABÜK</option> <option value="39">KARAMAN</option> <option value="40">KARS</option> <option value="41">KASTAMONU</option> <option value="42">KAYSERİ</option> <option value="43">KIBRIS</option> <option value="44">KIRIKKALE</option> <option value="45">KIRKLARELİ</option> <option value="46">KIRŞEHİR</option> <option value="47">KOCAELİ</option> <option value="48">KONYA</option> <option value="49">KÜTAHYA</option> <option value="50">KİLİS</option> <option value="51">MALATYA</option> <option value="52">MANİSA</option> <option value="53">MARDİN</option> <option value="54">MERSİN (İÇEL)</option> <option value="55">MUĞLA</option> <option value="56">MUŞ</option> <option value="57">NEVŞEHİR</option> <option value="58">NİĞDE</option> <option value="59">ORDU</option> <option value="60">OSMANİYE</option> <option value="61">RİZE</option> <option value="62">SAKARYA</option> <option value="63">SAMSUN</option> <option value="64">SELF SERVIS</option> <option value="65">SİNOP</option> <option value="66">SİSTEM</option> <option value="67">SİVAS</option> <option value="68">SİİRT</option> <option value="69">TEKİRDAĞ</option> <option value="70">TOKAT</option> <option value="71">TRABZON</option> <option value="72">TTNET ADSL</option> <option value="73">TUNCELİ</option> <option value="74">ULUSLAR-ARASI</option> <option value="75">UŞAK</option> <option value="76">VAN</option> <option value="77">YALOVA</option> <option value="78">YOZGAT</option> <option value="79">ZONGULDAK</option> <option value="80">ÇANAKKALE</option> <option value="81">ÇANKIRI</option> <option value="82">ÇORUM</option> <option value="83">İSTANBUL(ANADOLU)</option> <option value="84">İSTANBUL(AVRUPA)</option> <option value="85">İSTEK GENEL MÜDÜRLÜK</option> <option value="86">İZMİR</option> <option value="87">ŞANLIURFA</option> <option value="88">ŞIRNAK</option></select> <button class="btn btn-sm btn-primary" @click="byMudurluk()">
                                    Sorgula
                                </button></div></div></div></div></div></div></div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{
                    enabled: false,
                    placeholder: 'Arama İçin Enter\'a Basınız'
                  }"
                @on-search="onSearch"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-selected-rows-change="selectionChanged"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
  </Layout>
</template>